import { Grid } from '@mui/material'

import { AssetsTable } from '../../components/assets-table'
import { CurrencySunburstChart } from '../../components/currency-sunburst-chart'
import { FeeSunburstChart } from '../../components/fee-sunburst-chart'
import { NotesTable } from '../../components/notes-table'
import { PortfolioSunburstChart } from '../../components/portfolio-sunburst-chart'
import { StrategySunburstChart } from '../../components/strategy-sunburst-chart'
import { TotalAccountValueChart } from '../../components/total-account-value-chart'
import { ReportingTemplate } from '../../templates/top-level-tab-template'
import classes from './index.module.scss'

export const ReportingOverview = () => (
  <ReportingTemplate withOverflow withPadding backgroundColor="grey" tabValue="overview">
    <Grid container className={classes.root} spacing={4}>
      <Grid item xs={12}>
        <TotalAccountValueChart />
      </Grid>
      <Grid item xs={12}>
        <NotesTable />
      </Grid>
      <Grid item xs={6}>
        <PortfolioSunburstChart />
      </Grid>
      <Grid item xs={6}>
        <StrategySunburstChart />
      </Grid>
      <Grid item xs={12}>
        <AssetsTable />
      </Grid>
      <Grid item xs={6}>
        <CurrencySunburstChart />
      </Grid>
      <Grid item xs={6}>
        <FeeSunburstChart />
      </Grid>
    </Grid>
  </ReportingTemplate>
)
